import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  highlight: {
    color: theme.palette.primary.main
  }
}));
